/**
 * 加密
 */
 const CryptoJS = require('crypto-js');
 const config = require('../api/config');
 // require('@modules/crypto-js/cipher-core.js');
 // require('@modules/crypto-js/md5.js');
 // require('@modules/crypto-js/tripledes.js');
 
 // const key = '23834aafb74a477f23834aaf';
 // const iv = '8f8294ad';
 
 const Security = {
 
   // 加密
   encode(msg) {
     const msgHex = CryptoJS.enc.Latin1.parse(msg);
     const keyHex = CryptoJS.enc.Latin1.parse(config.key);
     const ivHex = CryptoJS.enc.Utf8.parse(config.iv);
 
     const encrypted = CryptoJS.TripleDES.encrypt(msgHex, keyHex, {
       mode: CryptoJS.mode.CBC,
       padding: CryptoJS.pad.Pkcs7,
       iv: ivHex,
     });
     const res = CryptoJS.enc.Hex.stringify(encrypted.ciphertext);
     return res.toUpperCase();
   },
 
   // 解密
   decode(msg) {
     const msgHex = CryptoJS.enc.Hex.parse(msg);
     const keyHex = CryptoJS.enc.Latin1.parse(config.key);
     const ivHex = CryptoJS.enc.Latin1.parse(config.iv);
 
     const decrypted = CryptoJS.TripleDES.decrypt(
       {
         ciphertext: msgHex,
       },
       keyHex,
       {
         mode: CryptoJS.mode.CBC,
         padding: CryptoJS.pad.Pkcs7,
         iv: ivHex,
       },
     );
     return CryptoJS.enc.Utf8.stringify(decrypted);
   },
 };
 
 window.Security = Security;
 
 module.exports = Security;
 